import closeIcon from "../../assets/close-icon.png";
import { useLanguage, getCustomsAgentManagementTranslation } from '../../hooks/useLanguage';

export const DeleteAgent = ({ closeDeleteModal, isLoading, agentToDelete, confirmDelete }) => {
    const [isSpanish] = useLanguage();
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-999">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md">
                <div className='flex justify-between items-center mb-4'>
                    <h2 className='text-2xl font-bold '>{getCustomsAgentManagementTranslation('confirmDeletion', isSpanish)}</h2>
                    <img className='h-6 w-6 cursor-pointer' src={closeIcon} onClick={closeDeleteModal} alt="Close" />
                </div>

                <p className="mb-8">
                    {getCustomsAgentManagementTranslation('areYouSureDelete', isSpanish)} "{agentToDelete.nombre}"? {getCustomsAgentManagementTranslation('thisActionCannotBeUndone', isSpanish)}
                </p>
                <div className='flex space-x-2'>
                    <button
                        onClick={confirmDelete}
                        className='bg-red-600 text-white rounded-full py-2 px-5 text-sm'
                        disabled={isLoading}
                    >
                        {isLoading ? getCustomsAgentManagementTranslation('deleting', isSpanish) : getCustomsAgentManagementTranslation('deleteAgent', isSpanish)}
                    </button>
                    <button
                        onClick={closeDeleteModal}
                        className='py-2 px-2 text-sm'
                        disabled={isLoading}
                    >
                        {getCustomsAgentManagementTranslation('cancel', isSpanish)}
                    </button>
                </div>
            </div>
        </div>
    )
}